import CustomersListContainer from "../../../components/asset-management/CustomersList";

export default function Customers() {
  return <CustomersListContainer />;
}
